<template>
  <div class="my_project">
    <mt-header title="我的工作">
      <mt-button slot="left" icon="back" @click.native="$router.push('/me')"></mt-button>
    </mt-header>
    <div class="my_type">
      <router-link class="myRelease" to="/myJobs" @click.native= 'mypjtSelect()' :class="{mypjtSelect:selected=='myJob'}" value="myJob">
        <i v-if="this.STATE.state.showReleaseTag > 0" class="red_icon"></i>
        我发布的
      </router-link>
      <router-link class="myJoin" to="/myJobs/join" @click.native= 'mypjtSelect()' :class="{mypjtSelect:selected=='myJoin'}" value="myJoin">
        我参与的
      </router-link>
      <router-link class="myRecommend" to="/myJobs/recommend" @click.native= 'mypjtSelect()' :class="{mypjtSelect:selected=='myRecommend'}" value="myRecommend">
        <i v-if='this.STATE.state.showRecommendTag > 0 && this.STATE.state.showRecommendTag < 99' class="red_icon hasNum">+{{this.STATE.state.showRecommendTag}}</i>
        <i v-if='this.STATE.state.showRecommendTag >= 99' class="red_icon hasNum">99+</i>
        推荐给我
      </router-link>
      <router-link class="myApply" to="/myJobs/apply" @click.native= 'mypjtSelect()' :class="{mypjtSelect:selected=='myApply'}" value="myApply">
        我申请的
      </router-link>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
export default {
  name: 'my_project',
  data () {
    return {
      selected: this.$route.query.select,
      icon: true,
      hasNum: true
    }
  },
  mounted () {
    console.log(this.STATE.state.chooseMyJob,"this.STATE.state.chooseMyJob")
    this.STATE.state.bottomindex='btnFive'
    if (this.selected === undefined) {
      this.selected = this.STATE.state.chooseMyJob
      if(this.selected==='myJob'){
        this.$router.push('/myJobs')
      }else if(this.selected==='myJoin'){
        this.$router.push('/myJobs/join')
      }else if(this.selected==='myRecommend'){
        this.$router.push('/myJobs/recommend')
      }else if(this.selected==='myApply'){
        this.$router.push('/myJobs/apply')
      }
    }
    if (this.STATE.state.loginState === false) {
      Toast({
        message: '请登录',
        position: 'middle',
        duration: 1000
      })
      this.$router.push({name: 'login', params: { fromPath: '/myJobs' }})
    } else {
      let _this = this
      this.axios.get('url/work/project/sumOfMyprojects?accountId=' + this.STATE.state.loginId)
      .then(function (res) {
        _this.STATE.state.showReleaseTag = res.data.showReleaseTag
        _this.STATE.state.showRecommendTag = res.data.showRecommendTag
      })
    }
  },
  methods: {
    mypjtSelect: function () {
      console.log(event.currentTarget.getAttribute('value'),"123")
      this.selected = event.currentTarget.getAttribute('value')
      this.STATE.state.chooseMyJob = event.currentTarget.getAttribute('value')
    }
  }
}
</script>
<style scoped>
  .my_type{
    text-align:center;
    border-bottom:1px solid #ccc;
    padding:12px 0;
  }
  .my_type a{
    display:inline-block;
    min-width: 56px;
    font-size:12px;
    margin:0 3px;
    line-height:26px;
    background-color:#f7f7f7;
    border:1px solid #dcdcdc;
    color:#000;
    text-decoration:none;
    -webkit-border-radiu:5px;
    -moz-border-radiu:5px;
    border-radius:5px;
    position:relative;
  }
  .red_icon{
     width:10px;
     height:10px;
     -webkit-border-radiu:50%;
     -moz-border-radiu:50%;
     border-radius:50%;
     background-color:red;
     position:absolute;
     top:-5px;
     right:-5px;
  }
  .hasNum{
     width:22px;
     height:22px;
     top:-10px;
     right:-10px;
     -webkit-transform:scale(0.7);
     color:#fff;
     font-style:normal;
  }
  .mypjtSelect{
    color:#fff!important;
    background-color:#108ee9!important;
  }
</style>



// WEBPACK FOOTER //
// my_project.vue?5e0418f5